/*
 * Paths that should not have alternate locales
 * Wildcard matching, i.e. /academy will match both /academy and /academy/slug-title and any path with language prefix, i.e. /sv/academy
 */
export const NO_ALTERNATE_PAGES_INCLUDES = ['/academy'] as const
